import { LoginInfo } from "../login/login";

function ForgetPassword() {
  return (
    <LoginInfo>
      <section className="login-page">
        <div className="container">
          <div className="login-form">
            <div className="form-header">
              {" "}
              <h1>Forget your password..!</h1>
              <p>Type your account email to recive reset link.</p>
            </div>
            <form>
              <div className="form-group inputWithIcon">
                <input type="email" placeholder="Email" />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  className="fa-envelope"
                >
                  <path
                    d="M20.0456 4.08331H7.79557C5.21824 4.08331 3.12891 6.17265 3.12891 8.74998V19.25C3.12891 21.8273 5.21824 23.9166 7.79557 23.9166H20.0456C22.6229 23.9166 24.7122 21.8273 24.7122 19.25V8.74998C24.7122 6.17265 22.6229 4.08331 20.0456 4.08331Z"
                    stroke="black"
                    stroke-opacity="0.4"
                    stroke-width="1.5"
                  />
                  <path
                    d="M3.18359 8.85498L11.5894 13.6733C12.2938 14.0821 13.0938 14.2973 13.9082 14.2973C14.7226 14.2973 15.5225 14.0821 16.2269 13.6733L24.6561 8.85498"
                    stroke="black"
                    stroke-opacity="0.4"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <button type="submit">Submit</button>
            </form>
          </div>
          <div className="login-background">
            <img
              src={
                process.env.PUBLIC_URL +
                "/photos/257cdf6122cadf5b56b96eddf37c41ea.webp"
              }
              alt="login-background"
            />
          </div>
        </div>
      </section>
    </LoginInfo>
  );
}
export default ForgetPassword;
